import * as formatter from "../../../../utils/formatter";
import {BALANCE_STATUS} from "../../../../utils/codes";

export const tabs = BALANCE_STATUS;

export const sizePerPageList = [
  { text: "30개 보기", value: 30 },
  { text: "50개 보기", value: 50 },
  { text: "100개 보기", value: 100 },
];

export const initialFilter = {
  filter: {
    balanceStatus: '',
  },
  sortField: "orderDate",
  sortOrder: "desc",
  pageNumber: 1,
  pageSize: 30,
};

export const columns = [
  {
    dataField: "id",
    text: "No.",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    dataField: "orderDate",
    text: "판매 일자",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.date,
  },
  {
    dataField: "prodName",
    text: "판매 상품명",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    dataField: "orderNo",
    text: "주문 번호",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    dataField: "orderCount",
    text: "판매 수량",
    headerClasses: 'text-center',
    classes: 'text-right',
    formatter: formatter.count,
  },
  {
    dataField: "calcPrice",
    text: "정산 금액",
    headerClasses: 'text-center',
    classes: 'text-right',
    formatter: formatter.price,
  },
];
